<div class="schedule-root">



  <div class="schedule-second-header">
    <img src="/assets/images/schedule_header_2.svg" />
    <div class="separator"></div>
    <p *ngIf="owner" class="title">
      Bonjour {{ owner.first_name }} {{ owner.last_name }},<br />
      Voici votre planning personnel.
      <span class="last-update">Dernière modification : {{ apiPlanning?.dates?.update | date:'dd/MM/yy' }}</span>
    </p>
  </div>

  <div class="content">
    <div *ngFor="let month of objectKeys(planning)">
      <div class="month-container">
        <span class="month">{{ month | date: 'MMMM y' }}</span>
      </div>

      <div class="item-container" *ngIf="(planning | json) != '{}'">
        <div class="item" *ngFor="let item of planning[month]">
          <div [ngClass]="{
              completed: item.isCompleted || item.timeState === 'PAST',
              milestone: item.type === 'milestone',
              task: item.type === 'task'
            }" class="line"></div>
          <div [ngClass]="{ completed: item.isCompleted || item.timeState === 'PAST' }" [ngStyle]="{
              height: item.type === 'milestone' ? '18px' : '15px',
              display: item.isFirst ? 'none' : 'block'
            }" class="line-2"></div>
          <img [ngClass]="{ completed: item.isCompleted || item.timeState === 'PAST' }" class="round" [ngStyle]="{
              'margin-left': item.type === 'milestone' ? '-11px' : '-13px',
              top: item.type === 'milestone' ? '17px' : '15px'
            }" [src]="
              item.type === 'milestone'
                ? item.timeState === 'FUTURE'
                  ? '/assets/images/future_milestone.svg'
                  : '/assets/images/past_milestone.svg'
                : item.timeState === 'FUTURE'
                ? '/assets/images/future_task.svg'
                : item.timeState === 'PAST'
                ? '/assets/images/completed_task.svg'
                : '/assets/images/ongoing_task.svg'
            " />
          <div *ngIf="item.type === 'milestone'" class="row item-card">
            <div class="col-md-3 no-padding">
              <span class="start_date">{{ item.start_date | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="col-md no-padding card-description">
              <span>{{ item.title }}</span>
            </div>
            <div class="col-md-5 no-padding card-last" *ngIf="item.customer_presence_required">
              <span><img src="/assets/images/schedule_arrow_right.svg" />{{
                item.customer_presence_required ? 'Votre présence est requise.' : ''
                }}</span>
            </div>
          </div>

          <div *ngIf="item.type === 'task'" class="item-big-card">
            <div>
              <span class="start_date">{{ item.start_date | date: 'dd/MM/yyyy' }}</span>
              <span class="state">
                {{
              item.timeState === 'ONGOING'
                ? 'En cours (reste : ' + item.leftDays + ' jours)'
                : item.timeState === 'FUTURE'
                ? 'Tâche à venir'
                : item.isCompleted
                  ? 'Tâche terminée'
                  : 'Tâche en cours'
              }}</span>
            </div>
            <div class="arrow-text">
              <div class="arrow" [ngClass]="{ completed: item.isCompleted || item.timeState === 'PAST' }">
                <img class="down" src="/assets/images/arrow_down.svg" />
              </div>
              <div class="text">
                <p class="title" [ngClass]="{ completed: item.isCompleted || item.timeState === 'PAST' }">
                  {{ item.title }}
                </p>
                <p class="description">{{ item.description }}</p>
              </div>
            </div>
            <div class="end_date">{{ item.end_date | date: 'dd/MM/yyyy' }}</div>
            <div class="circle-progress" [ngClass]="{ completed: item.isCompleted || item.timeState === 'PAST' }">
              <circle-progress [percent]="item.progress" [subtitle]="item.progress + '%'" innerStrokeColor="#00B7BE"
                               outerStrokeColor="#00B7BE" subtitleColor="#00B7BE" [animation]="false"></circle-progress>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

